module.exports = __webpack_public_path__ + "static/media/ascending.f29bfe2f.svg";